import { createSelector } from "reselect";
import get from "src/lib/get";
import { getData } from ".";

export const getUserId = createSelector(getData, (data) => {
  return get(data, "id", null);
});
